<template>
  <div class="invite-report">
    <!-- 搜索框 -->
    <searchBar @search="search" @resetForm="resetForm" @reload="fetchData" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      height="660"
    >
      <el-table-column label="意向酒店" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.hotelName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="宴会类型" align="center">
        <template slot-scope="scope">
          {{ getBanquetType(scope.row.banquetType) || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="用户类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.userTypeName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.userName) || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人手机号" align="center">
        <template slot-scope="scope">
          {{
            maskPhoneNumberFun(
              handledecrypt(scope.row.userMobile),
              scope.row.isShowAllPhone
            ) || '--'
          }}
        </template>
      </el-table-column>
      <el-table-column label="客户名称" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.customerName) || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="被推荐人手机号" align="center">
        <template slot-scope="scope">
          {{
            maskPhoneNumberFun(
              handledecrypt(scope.row.customerPhone),
              scope.row.isShowAllPhone
            ) || '--'
          }}
        </template>
      </el-table-column>
      <el-table-column label="推荐时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime || '--' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
      ref="Pagination"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>

<script>
import { HotelBanquetApi } from '@/api/hotel';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import searchBar from './components/searchBar'; // 搜索框
import { decrypt } from '@/utils/encryp';
import { encrypt } from '@/utils/encryp';
import { maskPhoneNumber } from '@/utils/index';
export default {
  components: {
    Pagination,
    searchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      pageSize: 0,
      pageIndex: 1,
      totalCount: 0,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    document.querySelector('.el-table__body-wrapper').style.height = '580px';
  },
  computed: {
    ...mapGetters(['paginObj']),
  },
  methods: {
    // 获取宴会类型
    getBanquetType(item) {
      let type = '';
      switch (item) {
        case 1:
          type = '婚宴';
          break;
        case 2:
          type = '生日宴';
          break;
        case 3:
          type = '商务宴';
          break;
        case 4:
          type = '升学宴';
          break;
        case 5:
          type = '会议';
          break;
        case 0:
          type = '其他';
          break;
        default:
          break;
      }

      return type;
    },

    maskPhoneNumberFun(str, isShowAllPhone) {
      if (isShowAllPhone) return str;
      return maskPhoneNumber(str);
    },

    // 解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },

    // 请求表单数据
    async fetchData() {
      try {
        this.listLoading = true;
        let res = await HotelBanquetApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          customerName: this.fromSearchObj?.customerName
            ? encrypt(this.fromSearchObj.customerName)
            : '',
          customerPhone: this.fromSearchObj?.customerPhone
            ? encrypt(this.fromSearchObj.customerPhone)
            : '',
          banquetType: this.fromSearchObj?.banquetType,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.totalCount = totalCount;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      this.paginObj.pageIndex = 1;
      if (obj) this.fromSearchObj = obj;
      this.fetchData();
    },

    // 重置
    resetForm() {
      this.paginObj.pageIndex = 1;
      this.paginObj.pageSize = 20;
      this.fromSearchObj = {};

      this.fetchData();
    },
    // 页面变化
    handleCurrentChange(obj) {
      this.paginObj.pageIndex = obj.pageIndex;
      this.fetchData();
    },
    // 分页改变页面数据
    handleSizeChange(obj) {
      this.paginObj.pageIndex = 1;
      this.paginObj.pageSize = obj.pageSize;
      this.fetchData();
    },
  },
};
</script>

<style lang="less">
@import './index.less';
</style>
